import React from 'react';
import { Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { HighlightCardWrapper, HighlightValue, HighlightLabel } from '../../styles/checkoutStyles';
import Colors from '../../../../../themes/Colors';

const HighlightCard = ({ value, label, tooltip }) => {
  return (
    <HighlightCardWrapper>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <HighlightLabel>{label}</HighlightLabel>
        <Tooltip title={tooltip}>
          <span style={{ cursor: 'pointer', color: Colors.white }}>
            <FontAwesomeIcon icon={faInfoCircle} />
          </span>
        </Tooltip>
      </div>
      <HighlightValue>{value}</HighlightValue>
    </HighlightCardWrapper>
  );
};

export default HighlightCard;
